import { render, staticRenderFns } from "./BuyerAccountPurchase.vue?vue&type=template&id=1321f03b&scoped=true"
import script from "./BuyerAccountPurchase.vue?vue&type=script&lang=js"
export * from "./BuyerAccountPurchase.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountPurchase.vue?vue&type=style&index=0&id=1321f03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321f03b",
  null
  
)

export default component.exports